import './ProfileContentLoader.css';

const ProfileContentLoader = ({ className = '', thin }) => {
  return (
    <div className={`gallery-profile-artists-loader ${thin ? 'thin' : ''} ${className}`}>
    </div>
  );
};

export default ProfileContentLoader;
